import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../_metronic/_partials/controls';
import * as actions from '../../_redux/usersActions';
import UserEditForm from './UserEditForm';

export function UserEditDialog({
  history,
  match: {
    params: { id },
  },
}) {
  const intl = useIntl();
  const [title, setTitle] = useState('');
  const titleText = intl.formatMessage({ id: 'USER.TITLE.DETAIL' });

  // Users UI Context
  // const UsersUIContext = useUsersUIContext();
  const UsersUIProps = useMemo(() => {
    return {
      initUser: {
        id: undefined,
        name: '',
        email: '',
        mobileNo: '',
        role: 'User',
        status: 0,
        type: 0,
        createdByName: '',
        updatedByName: '',
        createdAt: undefined,
        updatedAt: undefined,
      },
    };
  }, []);
  // const UsersUIProps = useMemo(() => {
  //   return {
  //     initUser: {
  //       id: undefined,
  //       name: '',
  //       email: '',
  //       mobileNo: '',
  //       role: 'User',
  //       status: 0,
  //       type: 0,
  //       createdByName: '',
  //       updatedByName: '',
  //       createdAt: undefined,
  //       updatedAt: undefined,
  //     },
  //   };
  // }, [UsersUIContext]);

  // Users Redux state
  const dispatch = useDispatch();
  const { actionsLoading, userForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.users.actionsLoading,
      userForEdit: state.users.userForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    // server call for getting User by id
    dispatch(actions.fetchUser(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? '' : intl.formatMessage({ id: 'USER.TITLE.DETAILNEW' });
    if (userForEdit && id) {
      _title = `${titleText} - [${userForEdit.id}]  ${userForEdit.name}`;
    }

    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userForEdit, actionsLoading]);

  // server request for saving User
  const saveUser = (user) => {
    if (!id) {
      // server request for creating User
      dispatch(actions.createUser(user)).then(() => onHide());
    } else {
      // server request for updating User
      dispatch(actions.updateUser(user)).then(() => onHide());
    }
  };

  const onHide = () => {
    history.push(`/users`);
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          {/* <button
            type='button'
            onClick={backToProductsList}
            className='btn btn-light'
          >
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}
          <button className='btn btn-light ml-2'>
            <i className='fa fa-redo'></i>
            Reset
          </button>
          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={saveProductClick}
          >
            Save
          </button> */}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className='mt-5'>
          <UserEditForm
            saveUser={saveUser}
            actionsLoading={actionsLoading}
            user={userForEdit || UsersUIProps.initUser}
            onHide={onHide}
          />
        </div>
      </CardBody>
    </Card>
    // <Modal
    //   size="lg"
    //   show={show}
    //   onHide={onHide}
    //   aria-labelledby="example-modal-sizes-title-lg"
    // >
    //   <UserEditDialogHeader id={id} />
    //   <UserEditForm
    //     saveUser={saveUser}
    //     actionsLoading={actionsLoading}
    //     user={userForEdit || UsersUIProps.initUser}
    //     onHide={onHide}
    //   />
    // </Modal>
  );
}
